import { ReactNode } from 'react';

// Company Header Types
export interface CompanyHeaderContent {
  companyName: string;
  tagLine: string;
  tagLine2: string;
}

// Section Types
export interface SectionContent {
  id: string;
  title: string;
  description?: string | ReactNode;
  fullHeight?: boolean;
  backgroundColor?: string;
  textColor?: string;
}

// Feature Types
export interface Feature {
  icon: string;
  title: string;
  description: string;
}

export interface FeaturesSectionContent extends SectionContent {
  features: Feature[];
}

// Hero Section Types
export interface HeroSectionContent extends SectionContent {
  ctaText: string;
  ctaAction?: string; // URL or action identifier
}

// Product Card Types
export interface ProductCardContent {
  name: string;
  unicodeLogo: string;
  tagline: string;
  description: string;
  ctaText: string;
  ctaHref: string;
  image?: string; // static image (optional)
  imageAnimated?: string; // animated image/gif (optional)
  useSvgLogo?: boolean; // use vMonad SVG logo instead of emoji
  svgLogo?: string; // specific SVG logo name (e.g., 'arc')
}

// Product Cards Content
export const productCards: ProductCardContent[] = [
  {
    name: "ARC",
    unicodeLogo: "🎬",
    tagline: "When AI becomes the creative director.",
    description: "An Agentic media editor where AI acts as the creative director. Describe your vision and AI drives the creation.",
    ctaText: "Learn More",
    ctaHref: "/game/blog/arc-editor",
    svgLogo: "arc"
  },
  {
    name: "MediaIQ",
    unicodeLogo: "👁️",
    tagline: "How AI learns from its own creations.",
    description: "Media intelligence enables a closed loop for generative media: generate, analyze, critique, and refine.",
    ctaText: "Learn More",
    ctaHref: "/game/blog/media-intelligence",
    svgLogo: "deepvision"
  },
  {
    name: "kHZ",
    unicodeLogo: "🎵",
    tagline: "Sound is the soul.",
    description: "vMonad's audio suite for voice design, voice cloning, and music generation. Engineered for emotion.",
    ctaText: "Learn More",
    ctaHref: "/game/blog/khz-audio-suite",
    svgLogo: "khz"
  },
  {
    name: "MediaGen",
    unicodeLogo: "🌀",
    tagline: "The unified media generation engine for AI agents.",
    description: "One engine for creating and understanding AI-native media across images, video, audio, and worlds.",
    ctaText: "Learn More",
    ctaHref: "/game/blog/mediagen-api",
    useSvgLogo: true
  }
];

// Products Section Types
export interface ProductsSectionContent extends SectionContent {
  header: string;
  subHeader: string;
  categoryTerm: string;
  closingLine: string;
  products: ProductCardContent[];
}

// Landing Page Content Type
export interface LandingPageContent {
  companyHeader: CompanyHeaderContent;
  heroSection: HeroSectionContent;
  productsSection: ProductsSectionContent;
  featuresSections: FeaturesSectionContent[];
}
